export default "__VITE_ASSET__CH$C13JE__"